export const ADD_CUSTOMER_START = "ADD_CUSTOMER_START"
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS"
export const ADD_CUSTOMER_ERROR = "ADD_CUSTOMER_ERROR"

export const EDIT_ORDER_START = "EDIT_ORDER_START"
export const EDIT_ORDER_SUCCESS = "EDIT_ORDER_SUCCESS"
export const EDIT_ORDER_ERROR = "EDIT_ORDER_ERROR"